import { dau } from 'api/config'

// DAU (Daily Active Users)
export const sendDAUEvents = (events, type = 'SIM') => {
  return dau.post(`dau/${type}`, events)
}
